import React, { Component } from 'react'

import InsurancePolicyInputs from './insurancePolicyInputs'
import { InsurancePolicy as Policy, Task } from '../types'
import moment from 'moment'

export interface Props {
  task: Task
}

export default class InsurancePolicy extends Component<Props> {
  render() {
    const { task } = this.props
    if (!task) return null

    const { verifiables, entityId } = task
    if (!verifiables) return null
    if (!entityId) return null

    let policy = (verifiables.find((v) => v.hasOwnProperty('companyName')) ||
      {}) as Policy
    policy.refiId = entityId.toString()

    if (policy.effectiveDate) {
      policy.effectiveDate = moment(policy.effectiveDate).format('MM/DD/YYYY')
    }

    if (policy.expirationDate) {
      policy.expirationDate = moment(policy.expirationDate).format('MM/DD/YYYY')
    }

    return <InsurancePolicyInputs initialValues={policy} policy={policy} />
  }
}
